import { TextField } from '@mui/material';
import { WorkoutSetMetric } from '@strength/domain-workout';

export const UneditableInput = ({
  setMetric,
}: {
  setMetric: WorkoutSetMetric;
}) => {
  return (
    <TextField
      disabled
      value={setMetric.input}
      InputProps={{
        sx: {
          mt: -3,
          width: '100%',
          '& input': {
            minWidth: `${String(setMetric.input).length}ch`,
          },
        },
      }}
    />
  );
};
